import { FeatureFlagDeclarations } from '../../../feature-flags/feature-flag-declarations';
import { useFeatureFlag } from '../../../feature-flags/hooks/use-feature-flag';
import { useShouldShowShippyButton } from './use-should-show-shippy-button';

export const useShouldRouteToShippy = (): boolean => {
  const shouldShowShippyButton = useShouldShowShippyButton();
  const isSierraChatEnabled = useFeatureFlag(FeatureFlagDeclarations.enableShippySierraChatIntegration);

  return shouldShowShippyButton && isSierraChatEnabled;
};
